import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { createNewPaymentMethod, fetchPaymentMethods, updateExistingPaymentMethod } from 'src/api/admin-paymentMethods';
import {
    CREATE_PAYMENT_METHOD_ADMIN,
    fetchAllPaymentMethods,
    FETCH_PAYMENT_METHODS_ADMIN,
    requestCreatePaymentMethod,
    requestCreatePaymentMethodFailure,
    requestCreatePaymentMethodSuccess,
    requestFetchAllPaymentMethods,
    requestFetchAllPaymentMethodsFailure,
    requestFetchAllPaymentMethodsSuccess,
    requestUpdatePaymentMethod,
    requestUpdatePaymentMethodFailure,
    requestUpdatePaymentMethodSuccess,
    UPDATE_PAYMENT_METHOD_ADMIN,
} from './actions';

function* fetchAllPaymentMethodsSaga(action: AnyAction): SagaIterator {
    yield put(requestFetchAllPaymentMethods());

    const { error, response } = yield call(fetchPaymentMethods);

    if (error) {
        yield put(requestFetchAllPaymentMethodsFailure(error));
    } else {
        yield put(requestFetchAllPaymentMethodsSuccess(response));
    }
}

function* createNewPaymentMethodSaga(action: AnyAction): SagaIterator {
    yield put(requestCreatePaymentMethod());

    const { error, response } = yield call(createNewPaymentMethod, action.newPaymentMethod);

    if (error) {
        yield put(requestCreatePaymentMethodFailure(error));
    } else {
        yield put(fetchAllPaymentMethods());
        yield put(requestCreatePaymentMethodSuccess(response));
    }
}

function* updateExistingPaymentMethodSaga(action: AnyAction): SagaIterator {
    yield put(requestUpdatePaymentMethod());

    const { error, response } = yield call(updateExistingPaymentMethod, action.updatedPaymentMethod);

    if (error) {
        yield put(requestUpdatePaymentMethodFailure(error));
    } else {
        yield put(fetchAllPaymentMethods());
        yield put(requestUpdatePaymentMethodSuccess(response));
    }
}

export function* generateFetchAllPaymentMethods() {
    yield takeLatest(FETCH_PAYMENT_METHODS_ADMIN, fetchAllPaymentMethodsSaga);
}

export function* generateCreateNewPaymentMethod() {
    yield takeLatest(CREATE_PAYMENT_METHOD_ADMIN, createNewPaymentMethodSaga);
}

export function* generateUpdatePaymentMethod() {
    yield takeLatest(UPDATE_PAYMENT_METHOD_ADMIN, updateExistingPaymentMethodSaga);
}
